import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const view = event.params.view

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.projectChartViewParam === view
      tab.setAttribute("aria-selected", selected.toString())
      tab.classList.toggle("border-orange-300", selected)
      tab.classList.toggle("bg-orange-50", selected)
      tab.classList.toggle("text-orange-800", selected)
      tab.classList.toggle("border-transparent", !selected)
      tab.classList.toggle("text-slate-600", !selected)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.projectChartView !== view)
    })
  }
}
